import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { IAccountButtonEvents, IAccountButtonFields } from '../components/types';
import { AccountButton } from '../components/AccountButton';
import { AccountButtonEvents } from './events';
import { getAuthUser, isLoggedUser } from '../../../../store/general/selectors';
import { EAuthUserRole } from '../../../../store/general/types';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState
  ): IAccountButtonFields => {
    const user = getAuthUser(state);
    const isLogged = isLoggedUser(state);

    return {
      userExist: !!user,
      isAdmin: !!user && user.role === EAuthUserRole.ADMIN,
      userName: user?.name || '',
      userPicture: user?.picture || '',
      isLogged,
    }
  };
}

const mapDispatchToProps = (
  dispatch: any,
): IAccountButtonEvents => ({
    onSignOut: () => dispatch(AccountButtonEvents.onSignOut()),
    onSwitchAccount: () => dispatch(AccountButtonEvents.onSwitchAccount()),
    onShowAdminPanel: () => dispatch(AccountButtonEvents.onShowAdminPanel()),
    onLoginAs: (email) => dispatch(AccountButtonEvents.onLoginAs(email)),
    onLogin: () => dispatch(AccountButtonEvents.onLogin()),
  }
);

export const AccountButtonHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountButton);

AccountButtonHOC.displayName = 'AccountButtonHOC';
